'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nestedtypes = require('nestedtypes');

var _nestedHateoas = require('@unitedtraders/nested-hateoas');

var _nestedHateoasCommonModels = require('@unitedtraders/nested-hateoas-common-models');

var _Market = require('./enums/Market');

var _Market2 = _interopRequireDefault(_Market);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TradingParameters(domainBuilder) {
  domainBuilder.defineModel('TradingParameters', 'tradingParameters', function (model) {
    return model.define({
      defaults: {
        user: _nestedHateoasCommonModels.LunaUser.value(null),
        market: _Market2.default.factory.value(null),
        dayBp: _nestedHateoasCommonModels.MoneyModel.value(null),
        nightBp: _nestedHateoasCommonModels.MoneyModel.value(null),
        orderShareLimit: Number.value(null),
        positionShareLimit: Number.value(null),
        maxOpenPositions: Number.value(null),
        stopLoss: _nestedHateoasCommonModels.MoneyModel.value(null),
        hardStopLoss: _nestedHateoasCommonModels.MoneyModel.value(null),
        canTrade: Boolean.value(null),
        minBalanceThreshold: _nestedHateoasCommonModels.MoneyModel.value(null),
        blockingCauses: Array.value(null),
        lastUpdatedAt: Date
      }
    });
  }).defineSearchMethod({
    name: 'findByUser',
    overrideUrl: 'api/admin/tradingParameters',
    query: _nestedtypes.Model.extend({
      defaults: {
        user: String.value(null) // LunaUser
      },
      getQueryPart: function getQueryPart() {
        return (0, _nestedHateoas.hash2query)({ user: this.user });
      }
    })
  }).defineSearchMethod({
    name: 'findMy',
    overrideUrl: 'api/me/tradingParameters'
  });
}

exports.default = TradingParameters;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/statements-domain/dist/models/TradingParameters.js
// module id = 741
// module chunks = 118